import { gql } from 'apollo-boost'

export const GET_CONSTRUCTION_DATA = gql`
  query getConstructionData {
    listUserSaleContracts {
      construction {
        id
        siengeCompanyId
        name
        address
        startDate
        endDate
        keysDelivery
        foundationProgress
        structureProgress
        complementsProgress
        generalProgress
        constructionLogo {
          id
          caption
          url
        }
        constructionSpecificAddress {
          street
          district
          federatedUnit
          city
        }
        medias {
          id
          caption
          url
          month
          year
          mediaType
        }
        documents {
          id
          url
          documentType
        }
        dashboardMedia {
          id
          url
        }
      }
      constructionUnit {
        id
        siengeId
        name
        note
      }
    }
  }
`
